/**
 * URL/query gated proof mode — Family B operator/proof surface separation.
 */
import { useEffect, useState } from 'react';
import {
  isOperatorProofModeFromSearchV0,
  resolveOperatorSurfaceClassV0,
  type OperatorSurfaceClassV0,
} from '@shared/operational-surface-responsive-composition';

function readSearch(): string {
  return typeof window !== 'undefined' ? window.location.search : '';
}

export function useOperatorProofModeV0(routeKind?: 'evidence' | 'system_proof' | 'operator'): {
  proofMode: boolean;
  surfaceClass: OperatorSurfaceClassV0;
} {
  const [proofMode, setProofMode] = useState(() => isOperatorProofModeFromSearchV0(readSearch()));

  useEffect(() => {
    const sync = () => setProofMode(isOperatorProofModeFromSearchV0(window.location.search));
    sync();
    window.addEventListener('popstate', sync);
    return () => window.removeEventListener('popstate', sync);
  }, []);

  return {
    proofMode,
    surfaceClass: resolveOperatorSurfaceClassV0({ proofMode, routeKind }),
  };
}

export default useOperatorProofModeV0;
